import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { PageHero } from "@/components/PageHero";
import { Marquee } from "@/components/Marquee";

const PRINCIPLES = [
  {
    num: "01",
    title: "Επιστήμη πρώτα",
    desc: "Κάθε έκδοση, εργαλείο και σεμινάριο ξεκινά από τεκμηριωμένη γνώση — όχι από τάσεις.",
  },
  {
    num: "02",
    title: "Η πράξη μετράει",
    desc: "Η γνώση αξίζει όταν μετατρέπεται σε κάτι χρήσιμο για τον θεραπευτή, τον εκπαιδευτικό, τον φροντιστή.",
  },
  {
    num: "03",
    title: "Ο άνθρωπος στο κέντρο",
    desc: "Η τεχνολογία είναι εργαλείο. Η σχέση, η επικοινωνία και η φροντίδα παραμένουν ανθρώπινες.",
  },
];

export default function About() {
  return (
    <div data-testid="about-page">
      <PageHero
        eyebrow="Για εμάς"
        title="Όλα ξεκίνησαν από την πράξη."
        text="Από τη λογοθεραπεία, τη νευροαποκατάσταση, την ειδική αγωγή και την εκπαίδευση — σε μια νέα κατεύθυνση."
      />

      <section className="pb-20 sm:pb-28 bg-cream">
        <div className="max-w-3xl mx-auto px-4 sm:px-6">
          <Reveal>
            <p className="text-base sm:text-lg leading-relaxed text-ink/85">
              Η πορεία μας ξεκίνησε στην κλινική πράξη: σε θεραπευτήρια, σχολεία και σπίτια, δίπλα σε ανθρώπους που δουλεύουν
              καθημερινά με τον λόγο, τη μνήμη και τη μάθηση. Εκεί μάθαμε τι σημαίνει πραγματικά χρήσιμο υλικό — και τι λείπει.
            </p>
            <p className="text-base sm:text-lg leading-relaxed text-ink/85 mt-6">
              Σήμερα, αυτή η εμπειρία εξελίσσεται σε μια νέα κατεύθυνση: εκδόσεις, ανάπτυξη ψηφιακών εργαλείων και λογισμικών,
              καθώς και σεμινάρια και εκπαιδευτικά προγράμματα. Στόχος μας είναι η επιστημονική γνώση να μετατρέπεται σε
              σύγχρονο, χρήσιμο και προσβάσιμο περιεχόμενο — σε λύσεις που ανταποκρίνονται στις ανάγκες επαγγελματιών,
              εκπαιδευτικών και φροντιστών.
            </p>
          </Reveal>
        </div>
      </section>

      <Marquee items={["Επιστήμη", "Πράξη", "Δημιουργία", "Επικοινωνία", "Μάθηση", "Φροντίδα"]} />

      <section className="bg-ink text-cream py-20 sm:py-28">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <Reveal>
            <p className="eyebrow text-terracotta">Οι αρχές μας</p>
          </Reveal>
          <Reveal delay={0.08}>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight mt-4">Τρία απλά πράγματα.</h2>
          </Reveal>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mt-14">
            {PRINCIPLES.map((p, i) => (
              <Reveal key={p.num} delay={i * 0.08}>
                <div className="border-t border-cream/20 pt-6" data-testid={`principle-${p.num}`}>
                  <span className="font-mono2 text-sm text-terracotta">{p.num}</span>
                  <h3 className="font-display text-2xl font-semibold mt-3">{p.title}</h3>
                  <p className="text-cream/60 text-sm leading-relaxed mt-3">{p.desc}</p>
                </div>
              </Reveal>
            ))}
          </div>
          <Reveal delay={0.2}>
            <Link
              to="/epikoinonia"
              data-testid="about-contact-cta"
              className="group inline-flex items-center gap-2 mt-14 bg-cream text-ink font-medium px-7 py-3.5 rounded-full transition-colors duration-300 hover:bg-terracottaD hover:text-cream"
            >
              Γνωρίστε μας καλύτερα
              <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
